import Vue from 'vue'
import App from './App.vue'
import moment from 'vue-moment'
import router from './router'
import store from './store'
import i18n from './i18n'

import IdleVue from 'idle-vue'

import VueCurrencyFilter from 'vue-currency-filter'

import Embed from 'v-video-embed'

// Service Worker
import './sw'

// Bootstrap
import '../node_modules/bootstrap/scss/bootstrap.scss'
import '../node_modules/bootstrap/dist/js/bootstrap.bundle'

// Lazysizes
import '../node_modules/lazysizes/lazysizes'
import { BPaginationNav, CollapsePlugin, BCard } from 'bootstrap-vue'

Vue.component('b-pagination-nav', BPaginationNav)
Vue.component('b-card', BCard)

Vue.config.productionTip = false

// Permet de visionner la video messagerie
Vue.use(Embed)

Vue.use(CollapsePlugin)
Vue.use(moment)
Vue.use(VueCurrencyFilter,
  {
    symbol: '',
    thousandsSeparator: ' ',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: '',
    symbolSpacing: ''
  })

// Gestion du timeout de session
const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 900000, // 15 minutes,
  startAtIdle: false
})

new Vue({
  data: {
    pdfLocation: process.env.VUE_APP_PDF_LOCATION
  },
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
